import { Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface ClearFiltersButtonProps {
  onClick: () => void;
}

export default function ClearFiltersButton({ onClick }: ClearFiltersButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="outlined"
      color="error"
      size="small"
      startIcon={<ClearIcon />}
      sx={{ mt: 2 }}
    >
      Очистити все
    </Button>
  );
}
